import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { NewsletterSignup } from "@/components/NewsletterSignup";

export const Footer = () => {
  return (
    <footer className="mt-16 border-t bg-card" role="contentinfo" aria-label="Fußbereich">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Gewerbeflächen</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten
                </Link>
              </li>
              <li>
                <Link to="/lagerhalle-mieten" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Lagerhalle mieten
                </Link>
              </li>
              <li>
                <Link to="/ladenflaeche-mieten" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Ladenfläche mieten
                </Link>
              </li>
              <li>
                <Link to="/geschaeftsraeume-mieten" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Geschäftsräume mieten
                </Link>
              </li>
              <li>
                <Link to="/ressourcen" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Ressourcen & Ratgeber
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Städte</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/gewerbeflaeche-mieten-berlin" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten Berlin
                </Link>
              </li>
              <li>
                <Link to="/gewerbeflaeche-mieten-hamburg" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten Hamburg
                </Link>
              </li>
              <li>
                <Link to="/gewerbeflaeche-mieten-muenchen" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten München
                </Link>
              </li>
              <li>
                <Link to="/gewerbeflaeche-mieten-frankfurt" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten Frankfurt
                </Link>
              </li>
              <li>
                <Link to="/gewerbeflaeche-mieten-koeln" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten Köln
                </Link>
              </li>
              <li>
                <Link to="/gewerbeflaeche-mieten-duesseldorf" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbefläche mieten Düsseldorf
                </Link>
              </li>
              <li>
                <Link to="/leipzig-gewerbeimmobilien" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Leipzig Gewerbeimmobilien
                </Link>
              </li>
              <li>
                <Link to="/stuttgart-gewerbeimmobilien" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Stuttgart Gewerbeimmobilien
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">In der Nähe</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/raum-mieten-in-der-naehe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Raum mieten in der Nähe
                </Link>
              </li>
              <li>
                <Link to="/saal-mieten-in-der-naehe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Saal mieten in der Nähe
                </Link>
              </li>
              <li>
                <Link to="/buero-in-meiner-naehe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Büro in meiner Nähe
                </Link>
              </li>
              <li>
                <Link to="/industriegebiet-in-meiner-naehe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Industriegebiet in meiner Nähe
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Gewerbegebiete</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/gewerbegebiete-deutschland" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbegebiete Deutschland
                </Link>
              </li>
              <li>
                <Link to="/gewerbegebiet-finden" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbegebiet in meiner Nähe finden
                </Link>
              </li>
              <li>
                <Link to="/gewerbegebiet" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbegebiet
                </Link>
              </li>
              <li>
                <Link to="/gewerbegebiet-in-der-naehe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbegebiet in der Nähe
                </Link>
              </li>
              <li>
                <Link to="/gewerbegebiet-arten" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Arten von Gewerbegebieten
                </Link>
              </li>
              <li>
                <Link to="/wohnen-im-gewerbegebiet" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Wohnen im Gewerbegebiet
                </Link>
              </li>
              <li>
                <Link to="/industriegebiet-in-meiner-naehe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Industriegebiet in meiner Nähe
                </Link>
              </li>

            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Ratgeber & Rechner</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/berechnung-von-miete" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Mietrechner Gewerbe
                </Link>
              </li>
              <li>
                <Link to="/mieteinnahmen-versteuern-rechner" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Mieteinnahmen versteuern
                </Link>
              </li>
              <li>
                <Link to="/rechner/lagerhalle-mietpreis" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Lagerhalle Mietpreis pro qm
                </Link>
              </li>
              <li>
                <Link to="/rechner/gewerbemiete-pro-qm" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbemiete pro qm
                </Link>
              </li>
              <li>
                <Link to="/rechner/ortsuebliche-vergleichsmiete-gewerbe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Ortsübliche Vergleichsmiete
                </Link>
              </li>
              <li>
                <Link to="/rechner/kaltmiete-gewerbe" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Kaltmiete Gewerbe berechnen
                </Link>
              </li>
              <li>
                <Link to="/rechner/vermieter-mietpreis" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Miete als Vermieter berechnen
                </Link>
              </li>
              <li>
                <Link to="/indexmiete-berechnen" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Indexmiete berechnen
                </Link>
              </li>
              <li>
                <Link to="/ressourcen/indexmiete" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Indexmiete erklärt
                </Link>
              </li>
              <li>
                <Link to="/portal-finder" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Portal-Finder
                </Link>
              </li>
              <li>
                <Link to="/rezension" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Plattform-Bewertungen
                </Link>
              </li>
              <li>
                <Link to="/ressourcen/gewerbeimmobilien-trends" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Trends 2026
                </Link>
              </li>
              <li>
                <Link to="/ressourcen/energieausweis-gewerbeimmobilien" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Energieausweis
                </Link>
              </li>
              <li>
                <Link to="/ressourcen/gewerbeimmobilien-verkaufen" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbeimmobilien verkaufen
                </Link>
              </li>
              <li>
                <Link to="/gewerbeversicherungen-vergleich" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Gewerbeversicherungen
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Rechtliches</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/ueber-uns" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/impressum" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/barrierefreiheit" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Barrierefreiheit
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-10 pt-8 border-t">
          <NewsletterSignup source="footer" className="max-w-2xl" />
        </div>

        <div className="mt-8 pt-8 border-t">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Gewerbefläche mieten. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/gewerbeimmobilien_dach/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gradient-to-tr from-purple-500 via-pink-500 to-orange-500 text-white hover:from-purple-600 hover:via-pink-600 hover:to-orange-600 transition-all hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?viewas=100000686899395&id=61583190131127"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-[#1877f2] text-white hover:bg-[#1565d8] transition-all hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
